import { memo, useContext } from "react";
import { BoletoContext } from "../../../contexts/BoletoContext";
import { BoletoHeaderText, ContractLoading } from "../../../styles/Boleto";
import SelectContract from "../../SelectContract/SelectContract";

const ContractNumber = () => {
  const { contracts, hasError } = useContext(BoletoContext);

  return (
    <BoletoHeaderText>
      Nº Contrato{" "}
      <strong>
        {hasError ? (
          " - "
        ) : contracts?.length ? (
          <SelectContract contracts={contracts} />
        ) : (
          <ContractLoading />
        )}
      </strong>
    </BoletoHeaderText>
  );
};

export default memo(ContractNumber);
